module.exports = __webpack_public_path__ + "img/in_banner2.ce8ef0e2.png";